import React from "react";
import { Typography } from "@mui/material";
import LegalLayout from "../components/LegalLayout";

export default function Terms() {
    return (
        <LegalLayout title="Terms of Service" updatedDate="July 18, 2026">
            <Typography component="p">
                These Terms of Service ("Terms") govern access to and use of the Kodex
                Shielding Solutions employee and subcontractor portal (the "Portal"). The
                Portal is an internal business system operated by Kodex Shielding Solutions
                for use by authorized employees, subcontractors, and other approved users.
                By logging in or otherwise using the Portal, you agree to these Terms.
            </Typography>

            <Typography component="h2">1. Authorized Use</Typography>
            <Typography component="p">
                Access to the Portal is limited to individuals who have been issued
                credentials by Kodex Shielding Solutions. Accounts are personal and may not
                be shared. You are responsible for all activity that occurs under your
                account and must notify your administrator promptly if you suspect
                unauthorized access.
            </Typography>

            <Typography component="p">
                The Portal is provided solely for business purposes, including timesheet
                and expense submission, project and field scheduling, engineering and shop
                records, reporting, and related company operations. Use of the Portal for
                any purpose outside the scope of your role or employment/subcontractor
                agreement is prohibited.
            </Typography>

            <Typography component="h2">2. Acceptable Use</Typography>
            <Typography component="p">You agree not to:</Typography>
            <ul>
                <li>
                    <Typography component="span">
                        Attempt to access data, projects, or accounts you are not authorized
                        to view;
                    </Typography>
                </li>
                <li>
                    <Typography component="span">
                        Submit false, inflated, or misleading timesheets, expenses, or reports;
                    </Typography>
                </li>
                <li>
                    <Typography component="span">
                        Interfere with or disrupt the operation, security, or integrity of the
                        Portal;
                    </Typography>
                </li>
                <li>
                    <Typography component="span">
                        Copy, distribute, or disclose Portal data outside the company except as
                        required for your work.
                    </Typography>
                </li>
            </ul>

            <Typography component="h2">3. Data You Submit</Typography>
            <Typography component="p">
                Information entered into the Portal — including hours worked, expenses,
                mileage, project and field data, engineering records, and uploaded
                documents — becomes company business records and may be reviewed, audited,
                and retained by Kodex Shielding Solutions in accordance with applicable
                recordkeeping requirements.
            </Typography>

            <Typography component="h2">4. Third-Party Integrations</Typography>
            <Typography component="p">
                The Portal may connect to third-party services to support company
                operations, including a QuickBooks Online accounting integration operated
                by Intuit Inc. Use of QuickBooks Online through the Portal is subject to
                Intuit's own terms, and details of what data is exchanged with QuickBooks
                Online are described in our Privacy Policy.
            </Typography>

            <Typography component="h2">5. Availability &amp; Changes</Typography>
            <Typography component="p">
                The Portal is provided on an "as is" and "as available" basis. Kodex
                Shielding Solutions may modify, suspend, or discontinue any part of the
                Portal, and may update these Terms from time to time. Continued use of the
                Portal after changes are posted constitutes acceptance of the revised Terms.
            </Typography>

            <Typography component="h2">6. Termination of Access</Typography>
            <Typography component="p">
                Access to the Portal may be suspended or terminated at any time, including
                upon separation of employment or end of a subcontractor engagement, or for
                violation of these Terms.
            </Typography>

            <Typography component="h2">7. Contact</Typography>
            <Typography component="p">
                Questions about these Terms should be directed to your manager or the Kodex
                Shielding Solutions administrative team.
            </Typography>
        </LegalLayout>
    );
}
